const initialState = {
  loaded: false,
  data: {},
  error: null,
  // asset preferences
  multiAddressMode: {},
  legacyAddressMode: {},
  taprootAddressMode: {},
  disabledPurposes: {},
}

export default initialState
